///<reference path="../short-cuts/index.d.ts"/>

module Meevo.Components.Controls {
    import CoSearchType = Meevo.Model.CoSearchType;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    "use strict";

    export class TemplateSearchResult {
        private itemsPerPage: number = 100;

        restrict = "E";
        templateUrl = 'app/components/controls/templateSearchResultTemplate.html';

        scope = {
            baseEndpoint: "@",
            filterTemplateUrl: "@",
            itemTemplateUrl: "@",
            visualState: "=",
            searchContext: "=",
            searchContextCriteria: "=",
            selectedItemId: "=",
            initialEditSection: "=",
            asLocationId: "=?",
            disableCrud: "=",
            view: "=",
            baseMainKey: "=?",
            advancedSearchTemplate: "@",
            advancedSearchMobileTemplate: "@?",
            chipTemplate: "@",
            templateController: "@",
            headerContentKey: "@",
            coSearchTemplate: "@?",
            coMobileSearchFilterTemplate: "@?",
            notificationBeforeAddState: "&?",
            supportsInactive: "=?"
        };


        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {

            scope.supportsInactive = angular.isDefined(scope.supportsInactive) ? scope.supportsInactive : true;

            /**
            * Determines whether the application is in CO mode
            */
            scope.isApplicationModeCO = (): boolean => {
                return this.identityService.inCentralOfficeMode();
            }

            if (angular.isUndefined(scope.searchContextCriteria)) {
                scope.criteria = {
                    includeActive: true,
                    view: scope.view,
                    coSearchType: null,
                    coBusinessTypeId: null,
                    coFilterByLocationId: null,
                    coSearchResultFilter: 0,
                    location: null,
                    businessType: null
                };
            } else {
                scope.criteria = angular.copy(scope.searchContextCriteria);
            }

            if (scope.isApplicationModeCO())
                scope.criteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;

            scope.intelligentSearch = {};
            scope.showAdvanced = false;

            let translate = this.$translate;

            //angular.element('#maint_form_search_container .virtualRepeatdemoInfiniteScroll #vertical-container').css('height', (angular.element('.main-content-container').height() - 185).toString());
            //angular.element(window).on('resize', function () {
            //  scope.$apply(function () {
            //    angular.element('#maint_form_search_container .virtualRepeatdemoInfiniteScroll #vertical-container').css('height', (angular.element('.main-content-container').height() - 185).toString());
            //  })
            //});


            scope.add = (): void => {
                scope.selectedItemId = null;
                // Handle add hook implementation
                if (_.isFunction(scope.notificationBeforeAddState)) {
                    scope.processNotificationBeforeAddState();
                }
                else {
                    scope.visualState = Model.MaintenanceFormVisualState.Detail;
                }
            }

            scope.processNotificationBeforeAddState = (): void => {
                scope.suppressSearch = true;
                scope.notificationBeforeAddState()
                    .then(result => {
                        scope.visualState = Model.MaintenanceFormVisualState.Detail;
                    })
                    .finally(() => { scope.suppressSearch = false; });
            }

            scope.detail = (id: Guid, typeId:number, atLocationId: number): void => {
                scope.asLocationId = atLocationId;
                if (id == undefined)
                    scope.selectedItemId = typeId;
                else scope.selectedItemId = id;


                if (scope.items && scope.items.loadedPages) {
                    scope.searchContext = scope.items.loadedPages[0];
                } else {
                    scope.searchContext = [];
                }

                // Need to clear this out in case user wants to search from the same context. FOR CLIENT CONTEXT
                if (scope.initialEditSection)
                    scope.initialEditSection = undefined;
                scope.visualState = Model.MaintenanceFormVisualState.Detail;
            }

            /* START: Infinite Scroll Data Retrieval */

            scope.toggleShowAdvanced = (): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    preserveScope: true,
                    scope: scope,
                    templateUrl: scope.advancedSearchTemplate,
                    controller: scope.templateController,
                    controllerAs: "vm",
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {

                    }
                }
                this.modalService.showCustom(options);

            }
            scope.toggleCoMenu = (): void => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    preserveScope: true,
                    scope: scope,
                    templateUrl: scope.coSearchTemplate,
                    controller: scope.templateController,
                    controllerAs: "vm",
                    escapeToClose: false,
                    clickOutsideToClose: false,
                    locals: {

                    }
                }
                this.modalService.showCustom(options);

            }


            scope.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, scope.baseEndpoint);
            scope.search = (): void => {
                if (scope.suppressSearch)
                    return;
                scope.hideCoFilters = true;
                scope.showCo = false;
                if (scope.maintenanceSearchForm.$valid) {

                    if (!(scope.criteria.location == null || scope.criteria.location.id === undefined || scope.criteria.location.id == null || scope.criteria.location.id.length <= 0)) {
                        scope.criteria.coFilterByLocationId = scope.criteria.location.id;
                    }
                    else {
                        scope.criteria.coFilterByLocationId = null;
                    }

                    if (!(scope.criteria.businessType == null || scope.criteria.businessType.id === undefined || scope.criteria.businessType.id == null || scope.criteria.businessType.id.length <= 0)) {
                        scope.criteria.coBusinessTypeId = scope.criteria.businessType.id;
                    }
                    else {
                        scope.criteria.coBusinessTypeId = null;
                    }

                    if (!scope.criteria.includeActive && !scope.criteria.includeInactive && !scope.criteria.includeDeleted) {

                        scope.closeModal();
                        scope.clearAdvancedSearch();

                    } else {

                        let request = {
                            pageNumber: 0,
                            itemsPerPage: this.itemsPerPage,
                            criteria: scope.criteria,
                            //sortBy: '',  default should be null so it can be used as the stored procs default
                            sortDirection: Model.SortDirection.Ascending,
                            asLocationId: scope.locationId
                        }
                        // Always pass criteria and add value into filter
                        // TODO: Refactor out intelligentSearch and just use filter
                        var filterValue = Model.Guard.isSomething(`%${scope.intelligentSearch.filter}%`) ? scope.intelligentSearch.filter : null;
                        scope.criteria.filter = filterValue;
                        // Close advanced search
                        scope.closeModal();
                        var savedRequest = angular.copy(request);
                        scope.items.initSearch(savedRequest);
                    }
                } else {
                    this.modalService.error("MESSAGE_INVALID_SEARCH");
                }
            }

            scope.clearAdvancedSearch = (): void => {

                scope.clearAdvancedSearchNoSubmit();
                scope.search();
            }

            scope.clearAdvancedSearchAndFilter = (): void => {
                scope.clearFilter();
                scope.initializeCriteria();
                scope.search();
            }

            scope.clearFilter = (): void => {
                scope.intelligentSearch.filter = null;
                scope.criteria.filter = null;
            }

            scope.initializeCriteria = (): void => {
                if (Model.Guard.isSomething(scope.searchContextCriteria)) {
                    // Applies custom criteria
                    scope.criteria = angular.copy(scope.searchContextCriteria);
                    // Ensures criteria is truthy
                    scope.criteria.includeActive = true;
                    scope.criteria.view = scope.view;
                }
            }

            scope.getAddSecurityKey = (): string => {
                return scope.baseMainKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE
            }
            scope.clearAdvancedSearchAndApply = (): void => {

                scope.clearAdvancedSearchNoSubmit();
                scope.closeModal();
            }


            scope.clearAdvancedSearchNoSubmit = (): void => {

                if (scope.isApplicationModeCO()) {
                    scope.criteria.includeActive = true;
                    scope.criteria.includeInactive = false;
                    scope.criteria.includeDeleted = false;
                    scope.criteria.coSearchType = CoSearchType.CentralOffice;
                } else {
                    scope.criteria = {
                        includeActive: true,
                        includeInactive: false,
                        includeDeleted: false,
                        LevelSetting: Meevo.Model.LevelSettingEnum.Location,
                        includeSystemLevel: true,
                        view: scope.view
                    }

                };
            }


            /* END: Infinite Scroll Data Retrieval */



            scope.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }

            scope.closeModal = (): void => {
                this.$mdDialog.cancel();
            }

            //scope.toggleCoMenu = (): void => {
            //    scope.showCo = !scope.showCo;
            //}

            scope.toggleFilter = (key, $event): void => {
                scope.criteria[key] = !scope.criteria[key];
                $event.stopPropagation();
                scope.search();
            }
            scope.toggleSearchFilter = ($event): void => {
                scope.intelligentSearch.filter = '';
                $event.stopPropagation();
                scope.search();
            }

            scope.toggleShowAdvancedMobile = () => {
                scope.showAdvancedMobile = !scope.showAdvancedMobile;
            }

            const searchShortCutGroup = new ShortCutGroup([
                {shortCutName: 'DATA_MAINTENANCE_ADD', callback: () => scope.add(true)}
            ], {noun: scope.noun});

            scope.$watch('visualState', (newValue) => {
                if(newValue === Model.MaintenanceFormVisualState.Search) {
                    this.shortCutsService.activateGroup(searchShortCutGroup);
                }
            });

            scope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
                if (toState.name === this.$state.current.name && scope.visualState === Model.MaintenanceFormVisualState.Search) {
                    this.shortCutsService.activateGroup(searchShortCutGroup);
                } else if (fromState.name === this.$state.current.name) {
                    this.shortCutsService.deactivateGroup(searchShortCutGroup);
                }
            });

            this.shortCutsService.activateGroup(searchShortCutGroup);

        }



        constructor(
            private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private loggingService: Meevo.Components.Logging.ILoggingService,
            private modalService: Meevo.Components.Modal.IModalService,
            private $mdDialog: ng.material.IDialogService,
            private $translate: angular.translate.ITranslateService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: angular.IRootScopeService,
                $state: angular.ui.IStateService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                trackingService: Meevo.Components.Tracking.ITrackingService,
                loggingService: Meevo.Components.Logging.ILoggingService,
                modalService: Meevo.Components.Modal.IModalService,
                $mdDialog: ng.material.IDialogService,
                $translate: angular.translate.ITranslateService,
                identityService: Meevo.Components.Common.IIdentityService,
                 shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) => {
                return new TemplateSearchResult($rootScope, $state, dataService, trackingService,
                    loggingService, modalService, $mdDialog, $translate, identityService, shortCutsService);
            }

            directive.$inject = ["$rootScope", "$state", "meevo.components.common.DataService",
                "meevo.components.tracking.TrackingService",
                "meevo.components.logging.LoggingService",
                "meevo.components.modal.ModalService", "$mdDialog", "$translate", "meevo.components.common.IdentityService", "meevo.components.short-cuts.ShortCutsService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoTemplateSearchResult", TemplateSearchResult.factory());
}
